<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>
              Cấu hình yêu cầu báo cáo định kỳ
            </strong>
          </div>
          <b-form @submit.prevent="search">
            <b-row>
              <b-col offset-md="3">
                <b-form-group label="Nguồn báo cáo:"
                              label-for="username"
                              label-cols-md="2"
                              :horizontal="true"
                              label-align="left">
                  <b-col md="6 no-padding">
                    <select2 placeholder="--- Chọn nguồn báo cáo ---"
                             v-if="listSyncDataSources.length > 0"
                             v-model="searchForm.syncDataSourceId"
                             :options="listSyncDataSources" allowClear>
                    </select2>
                  </b-col>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col offset-md="3">
                <b-form-group label="Loại báo cáo:"
                              label-for="unit"
                              label-cols-md="2"
                              :horizontal="true"
                              label-align="left">
                  <treeselect v-model="searchForm.reportTypeId"
                              placeholder="--- Chọn loại báo cáo ---"
                              :disable-branch-nodes="true"
                              :show-count="true"
                              class="col-md-6 no-padding"
                              :options="listReportsAvailable" />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col offset-md="3">
                <b-form-group label="Từ khóa tìm kiếm:"
                              label-for="username"
                              label-cols-md="2"
                              :horizontal="true"
                              label-align="left">
                  <b-form-input type="text" id="search"
                                class="col-md-6"
                                placeholder="Nhập từ khóa tìm kiếm ..."
                                v-model="searchForm.str">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col offset-md="3">
                <b-form-group label="Trạng thái hoạt động:"
                              label-for="username"
                              label-cols-md="2"
                              :horizontal="true"
                              label-align="left">
                  <b-form-radio-group v-model="searchForm.isActive"
                                      style="padding-bottom: 7px"
                                      name="radio-sub-component">
                    <b-form-radio :value="null">Tất cả</b-form-radio>
                    <b-form-radio :value="true">Đang hoạt động</b-form-radio>
                    <b-form-radio :value="false">Ngưng hoạt động</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col offset-md="3">
                <b-form-group label="" :label-cols="4" label-cols-md="2">
                  <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
          <br />
          <b-grid :searchForm="searchForm"
                  :gridOptions="gridOptions"
                  dataUrl="system-parameters/report-request-parameters"
                  gridName="Danh sách cấu hình yêu cầu báo cáo định kỳ"
                  ref="reportRequestTable">
            <template v-slot:actions v-if="isAdmin">
              <router-link to="./create" tag="button" class="btn btn-primary" size="md">
                Thêm mới
              </router-link>
            </template>

            <template v-slot:cell(listUnitNames)="row">
              <span :title="row.value.join(', ')">
                {{ truncate(row.value.join(', ')) }}
              </span>
            </template>
            <template v-slot:cell(reportTypeId)="row">
              {{ $store.getters.getReportSyncTypeName(row.value) }}
            </template>
            <template v-slot:cell(periodType)="row">
              {{ $store.getters.getPeriodTypes(row.value) }}

            </template>
            <template v-slot:cell(periodTypeReportYear)="row">
              {{ $store.getters.getPeriodTypeReportYears(row.value) }}
            </template>
            <template v-slot:cell(requestFrequency)="row">
              <span :title="translateCron(row.value)">
                {{ row.value }}
              </span>
            </template>
            <template v-slot:cell(nextExecutionTime)="row">
              {{ row.value | formatTime }}
            </template>
            <template v-slot:cell(isActive)="row">
              <b-checkbox disabled :checked="row.value"></b-checkbox>
            </template>

            <template v-slot:cell(_actions)="row">
              <b-button-group>
                <b-button size="sm" :to="{ path: `./${row.item.id}/detail` }" title="xem" variant="info">
                  Xem
                </b-button>
                <template v-if="isAdmin">
                  <b-button size="sm" :to="{ path: `./${row.item.id}/edit` }" title="sửa" variant="primary">
                    Sửa
                  </b-button>
                  <b-button size="sm" @click.stop="remove(row.item, row.index, $event.target)" title="xóa" variant="danger">
                    Xoá
                  </b-button>
                </template>
              </b-button-group>
            </template>
          </b-grid>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { mixins } from '@/shared/mixins'
  import cronstrue from 'cronstrue';
  import '@/utils/cron_locale_vi';

  export default {
    name: 'ListReportRequest',
    mixins: [mixins],
    data() {
      return {
        searchForm: {
          str: null,
          reportTypeId: null,
          syncDataSourceId: null,
          isActive: true
        },
        gridOptions: {
          fields: [
            { key: 'name', label: 'Tên cấu hình', sortable: true },
            { key: 'reportTypeId', label: 'Loại báo cáo', sortable: true },
            //{ key: 'requestUrl', label: 'Đường dẫn gửi yêu cầu', sortable: false },
            { key: 'requestFrequency', label: 'Tần suất thực hiện', sortable: true },
            //{ key: 'reportRequestLoginUserUserName', label: 'Tài khoản người dùng gửi yêu cầu', sortable: false },
            { key: 'periodType', label: 'Loại báo cáo theo thời kỳ', sortable: true },
            { key: 'periodStartTime', label: 'Thời điểm bắt đầu báo cáo', sortable: true },
            { key: 'periodEndTime', label: 'Thời điểm kết thúc báo cáo', sortable: true },
            { key: 'periodTypeReportYear', label: 'Năm xuất báo cáo', sortable: true },
            { key: 'syncDataSourceName', label: 'Nguồn báo cáo', sortable: true },
            { key: 'listUnitNames', label: 'Đơn vị', sortable: false },
            { key: 'nextExecutionTime', label: 'Ngày thực thi tiếp theo', sortable: true },
            { key: 'isActive', label: 'Trạng thái hoạt động', sortable: true }
          ],
          sortBy: 'id',
          sortDesc: true
        },
        reportRequest: {
          requestUrl: null,
          requestFrequency: null,
          requestUserId: null,
          periodType: 1,
          periodStartTime: 1,
          reportTypeId: null,
          syncDataSourceId: null
        },
        listReportsBySyncDataSource: []
      }
    },
    computed: {
      ...mapState({
        listReports: (state, getters) => getters.getTreeReportByReportType,
        listRequestUsers: (state, getters) => getters.getReportRequestLoginUsers(),
        listSyncDataSources: (state, getters) => getters.getSyncDataSources
      }),
      listReportsAvailable() {
        return this.searchForm.syncDataSourceId ? this.listReportsBySyncDataSource : this.listReports;
      }
    },
    created() {

    },
    watch: {
      'searchForm.syncDataSourceId'(newVal) {
        this.loadReportTypeBySyncDataSource(newVal);
      }
    },
    methods: {
      search() {
        this.$refs.reportRequestTable.refresh();
      },
      loadReportTypeBySyncDataSource(syncDataSourceId) {
        if (syncDataSourceId) {
          var vm = this;
          vm.$services
            .get(`lookup/report-types/${syncDataSourceId}/list`)
            .done((response) => {
              vm.listReportsBySyncDataSource =
                vm.$store.getters.getTreeReportByReportTypes(response);
            });
        }
      },
      remove(item, index, button) {
        var vm = this;
        if (confirm('Bạn có chắc chắn muốn xóa cấu hình yêu cầu báo cáo định kỳ này?')) {
          this.$services.delete(`system-parameters/report-request-parameters/${item.id}`).done(() => {
            vm.$toastr.s('Xóa cấu hình yêu cầu báo cáo định kỳ thành công');
            vm.search();
          });
        }
      },
      truncate(text, maxLength) {
        maxLength = maxLength ?? 200;
        if (text.length > maxLength) {
          return text.substr(0, maxLength) + ' ...';
        } else {
          return text;
        }
      },
      translateCron(cronExpression) {
        try {
          return this.normalizeCronTransalation(cronstrue.toString(cronExpression, { locale: 'vi' }));
        } catch {
          return cronExpression;
        }
      },
      normalizeCronTransalation(translation) {
        return translation.replace('của tháng, chỉ tính trong Tháng', 'của Tháng');
      }
    }
  }

</script>
<style scoped>
</style>
